import React from "react";
import UserAvatar from "./UserAvatar";

const ConversationItem = ({
  conversation,
  currentUserId,
  isSelected,
  onSelect,
}) => {
  const otherUser = conversation.participants?.find(
    (p) => p._id?.toString() !== currentUserId?.toString(),
  );

  const lastMsg = conversation.lastMessage;
  const time = conversation.updatedAt
    ? new Date(conversation.updatedAt).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      })
    : "";

  return (
    <div
      onClick={() => onSelect(conversation)}
      className={`flex items-start gap-2 md:gap-3 px-3 md:px-4 py-2 md:py-3 cursor-pointer transition-colors border-b border-gray-100 dark:border-gray-700 ${
        isSelected
          ? "bg-blue-50 dark:bg-gray-700"
          : "hover:bg-gray-50 dark:hover:bg-gray-800"
      }`}
    >
      <UserAvatar user={otherUser} />

      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-2">
          <span className="font-semibold text-xs md:text-sm truncate dark:text-white">
            {otherUser
              ? `${otherUser.firstName || ""} ${otherUser.lastName || ""}`.trim()
              : "Unknown User"}
          </span>
          <span className="text-[10px] md:text-xs text-gray-400 flex-shrink-0">
            {time}
          </span>
        </div>
        <p className="text-[10px] md:text-xs text-gray-500 dark:text-gray-400 truncate mt-0.5">
          {lastMsg?.content || "No messages yet"}
        </p>
      </div>
    </div>
  );
};

export default ConversationItem;
